import React, { PropsWithChildren } from 'react'

import { useSelector } from 'react-redux'

import { TrackedRoute } from '@components/UI/TrackedRoute'
import { BrandFanFilters, EventTrackingNames } from '@enums'
import { IApplicationState } from '@store'
import { selectBrandFanStatsForCurrentFilter } from '@store/brandFans'
import { IBrand, selectBrands } from '@store/brands'
import {
  selectBrandFansCurrentView,
  selectCurrentBrandFansBrandFilter,
  selectCurrentBrandFansSort,
} from '@store/router'

interface IProps {
  brandName?: string
  sortBy?: string
  source: 'brand_filter' | 'sort_filter'
}

const ALL_BRANDS = 'all_brands'

const BrandFansInfluencerIdentityTopPanelTrackedRoute: React.FC<PropsWithChildren<IProps>> = ({
  source,
  children,
  brandName,
  sortBy,
}) => {
  const currentFilter = useSelector((state: IApplicationState) => selectBrandFansCurrentView(state))
  const count = useSelector((state: IApplicationState) =>
    selectBrandFanStatsForCurrentFilter(state),
  )
  const currentSort = useSelector((state: IApplicationState) => selectCurrentBrandFansSort(state))
  const currentBrandFilter = useSelector((state: IApplicationState) =>
    selectCurrentBrandFansBrandFilter(state),
  )
  const brands = useSelector((state: IApplicationState) => selectBrands(state))

  const brandNameToUse = brandName || currentBrandFilter
  const selectedBrand =
    (brandNameToUse !== ALL_BRANDS && brands.find((brand) => brand.name === brandNameToUse)) ||
    ({} as IBrand)
  return (
    <TrackedRoute
      eventName={
        currentFilter === BrandFanFilters.BrandFans
          ? EventTrackingNames.BrandFansViewBrandFans
          : EventTrackingNames.BrandFansViewAllCreators
      }
      properties={{
        source,
        number_of_identities: count,
        target_brand_filter_name: brandNameToUse,
        target_brand_filter_id: selectedBrand.id,
        target_sort_filter: sortBy || currentSort,
      }}
    >
      {children}
    </TrackedRoute>
  )
}

export { BrandFansInfluencerIdentityTopPanelTrackedRoute }
export default BrandFansInfluencerIdentityTopPanelTrackedRoute
